export default __webpack_public_path__ + "static/media/servicos.e07f05b8.jpg";